import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", referral_code: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await register(form.name, form.email, form.password, form.referral_code);
      toast.success("Welcome to Aura & Co.");
      navigate("/account");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };
  return (
    <main className="max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <p className="eyebrow text-neutral-600">Account</p>
      <h1 className="font-serif text-4xl mt-2 mb-10">Create account</h1>
      <form onSubmit={submit} className="space-y-4">
        <input required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
          data-testid="register-name" className="w-full bg-cream border border-hair px-4 py-3.5 text-sm outline-none focus:border-[var(--gold)]" />
        <input type="email" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
          data-testid="register-email" className="w-full bg-cream border border-hair px-4 py-3.5 text-sm outline-none focus:border-[var(--gold)]" />
        <input type="password" required minLength={6} placeholder="Password (min 6)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
          data-testid="register-password" className="w-full bg-cream border border-hair px-4 py-3.5 text-sm outline-none focus:border-[var(--gold)]" />
        <input placeholder="Referral code (optional)" value={form.referral_code} onChange={(e) => setForm({ ...form, referral_code: e.target.value.toUpperCase() })}
          data-testid="register-referral" className="w-full bg-cream border border-hair px-4 py-3.5 text-sm uppercase outline-none focus:border-[var(--gold)]" />
        <button disabled={loading} className="btn-primary w-full" data-testid="register-submit">{loading ? "Creating…" : "Create Account"}</button>
      </form>
      <p className="text-sm text-neutral-500 mt-6">Already have an account? <Link to="/login" className="underline text-neutral-900">Sign in</Link></p>
    </main>
  );
}
